/* eslint-disable ember/no-classic-components, ember/no-component-lifecycle-hooks, ember/require-tagless-components */
import Component from '@ember/component';
import reframe from 'reframe.js';
import MediaSource from '@linc-technologies/linced-common/enums/media-source';
import MediaType from '@linc-technologies/linced-common/enums/media-type';

export default class PageDetails extends Component {
  MediaSource = MediaSource;
  MediaType = MediaType;

  // Props
  // opened provides the state of whether the page details dialog is opened.
  open = false;

  // onToggle provides an action to be called to alter the state of opened.
  onToggle() {}

  // icon provides the icon to set in the modal dialog.
  icon = '';

  // title provides the title to set in the modal dialog.
  title = '';

  // description provides the report description.
  description = '';

  // media provides a media record to display embedded media on the report page.
  media = null;

  // Lifecycle
  didRender() {
    super.didRender(...arguments);
    reframe(`.page-details-media iframe`);
  }
}
